export default __webpack_public_path__ + "static/media/default-benefit.7a7ecdb3.svg";